import { FC } from 'react'
import { LabeledText } from '../../../../../../components/CustomTypography'
import { StyledCard } from '../../../../../../components/StyledCard'
import {Box} from "@mui/material"

interface IGrantCardProps {
  agency: string
  deadline: string
  grantTitle: string
  awardAmount: string
  technologyTitle: string
}

export const GrantCard: FC<IGrantCardProps> = ({
  agency,
  deadline,
  grantTitle,
  awardAmount,
  technologyTitle,
}) => {
  return (
    <StyledCard
      sx={{
        p: 2,
        display: 'flex',
        minHeight: '230px',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <LabeledText value={grantTitle} valueProps={{ fontSize: '0.9rem' }} />
        <LabeledText
          value={agency}
          valueProps={{ fontSize: '0.9rem', color: 'secondary.light', fontWeight: 500 }}
        />
      </Box>

      <LabeledText
        label="Project"
        value={technologyTitle}
        valueProps={{ fontSize: '0.9rem' }}
        rootContainerProps={{
          my: 1,
          gap: 0,
          direction: 'column',
          alignItems: 'flex-start',
        }}
      />

      <LabeledText
        label="Award amount"
        value={`$${awardAmount}`}
        valueProps={{ fontSize: '0.9rem' }}
        rootContainerProps={{
          my: 1,
          gap: 0,
          alignItems: 'flex-start',
          direction: 'column',
        }}
      />

      <LabeledText
        label="Dealine"
        value={deadline}
        valueProps={{ fontSize: '0.9rem' }}
        rootContainerProps={{
          my: 1,
          gap: 0,
          alignItems: 'flex-start',
          direction: 'column',
        }}
      />
    </StyledCard>
  )
}
